import {ApiService} from "../index";
import {APIConfig} from "../../../constants";

const createTicket = (payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.ADD_TICKET.METHOD](APIConfig.ADD_TICKET.URL, payload);
}

const TicketService = {
    createTicket
};

export default TicketService;
